﻿export const SNAP_VERSION = 2;

// Most common keyboard commands (mostly unprintable keycodes right now)
export enum keyboard {
    backspace = 8,
    tab = 9,
    enter = 13,
    shift = 16,
    ctrl = 17,
    alt = 18,
    pause = 19,
    capslock = 20,
    escape = 27,
    pageup = 33,
    pagedown = 34,
    end = 35,
    home = 36,
    left = 37,
    up = 38,
    right = 39,
    down = 40,
    insert = 45,
    deleter = 46,
    space = 32,
    comma = 188
}

export enum events {
    loginRequested = "loginRequested",
    loginSuccessful = "loginSuccessful",
    logout = "logout",
    avatarChanged = "avatarChanged",
    permissionDenied = "permissionDenied",
}

export enum extensions {
    image = "jpg,png,gif,bmp",
    video = "mp4,webm,ogg,ogv",
    environments = "env,dds,hdr"
}

export const currencies = {
    USD: "$",
    EUR: "\u20ac",
    GBP: "\u00a3",
    AUD: "$",
    CAD: "$",
    JPY: "\u00a5"
};

export enum eDateUnit {
    seconds = "Seconds",
    minutes = "Minutes",
    hours = "Hours",
    date = "Date",
    month = "Month",
    fullYear = "FullYear"
}

export enum icons {
    error = "",
    childError = "",
    cancel = "",
    save = "",
    add = "", // "",
    minus = "",
    deleter = "",
    paste = "",
    anonymize = "",
    edit = "",
    hamburger = "",
    change = "",
    help = "",
    info = "",
    infoCircle = "",
    success = "",
    folder = "",
    upload = "",
    download = "",
    refresh = "",
    rename = "",
    crumb = "",
    image = "",
    addFolder = "",
    open = "",
    localization = "",
    camera = "",
    user = "",
    users = "",
    quote = "",
    products = "",
    standardProducts = "",
    company = "",
    gear = "",
    gears = "",
    role = "",
    roles = "", // "",
    theme = "",
    queue = "",
    builder = "",
    tag = "",
    tags = "",
    comment = "",
    attachment = "",
    rule = "", // "",
    popout = "",
    popin = "",
    play = "",    
    list = "",
    tile = "",
    search = "",
    earth = "",
    flag = "",
    mail = "",
    all = "",
    clear = "",
    dollar = "",
    template = "",
    templates = "",
    up = "",
    down = "",
    right = "",
    left = "",
    infrastructure = "",
    database = "",
    integrations = "",
    workflowSelector = "",
    tools = "",
    settings = "",
    permission = "",
    workflow = "",
    email = "",
    approve = "",
    reject = "",
    shipping = "",
    logout = "",
    deploy = "",
    globe = "",
    generators = "",
    generator = "",
    resources = "",
    output = "",
    cleanworkspace = "",
    undo = "",
    redo = "",
    bold = "",
    italic = "",
    heading = "",
    link = "",
    img = "",
    capture = "",
    submit = "",
    discount = "",
    log = "",
    zoomIn = "",
    zoomOut = "",
    visible = "",
    notVisible = "",
    table = "",
    chevronLeft = "",
    chevronRight = "",
    chevronUp = "",
    chevronDown = "",
    fullscreen = "",
    exitFullscreen = "",
    vr = "",
    clone = "",
    hand = "",
    embed = "",
    safeFunction = "",
    function = "",
    globalDefinition = "",
    reference = "",
    more = "",
    plus = "",
    removed = "",
    test = "",
    name = "",
    cloud = "",
    filter = "",
    warning = "",
    hotspot = "",
    threeD = "",
    cube = "",
    column = "",
    report = "",
    lock = "",
    layout = "",
    layoutConfig = "",
    channels = "",
    history = "",
    view = "",
    automationStudio = "",

    complete = "",
    generating = "",
    failed = "",

    cast = "",
    setVar = "",
    getVar = "",

    alignVertical = "",
    alignRight = "",
    alignLeft = "",
    alignTop = "",
    alignBottom = "",
    alignHorizontal = "",
    shrink = "",
    stretch = "",

    centerText = "",
    leftText = "",
    rightText = "",
    justifyText = "",
    leftIndent = "",
    rightIndent = "",

    rotateRight = "",
    rotateLeft = "",

    // configurator types
    actionBar = "",
    configurator = "",
    page = "",
    group = "",
    ruleContainer = "", // folder
    pricingRuleContainer = "",
    action = "",
    builds = "",
    build = "",
    tabControl = "◰", //"", //"",
    tab = "◳", //"", // "",
    gridRow = "▤", //"",
    gridColumn = "▥", // "",
    accordion = "",
    expander = "", //"",
    button = "",
    toolbar = "",
    popup = "",
    dropdownButton = "",
    content = "",
    priceWidget = "",
    pageControl = "", //"",
    viewer = "", //"",
    canvas = "",
    container = "",
    pageNavigator = "",
    pageTabs = "◰",
    nestedSet = "",

    // controls
    textbox = "",
    numberbox = "#",
    checkbox = "",
    select = "",
    none = "",
    colorPicker = "",
    colorSelect = "",
    slider = "",
    multilineTextbox = "",
    label = "L",
    imageSelect = "",
    imageMultiSelect = "",
    autoComplete = "",
    media = "",
    mediaPicker = "",
    html = "",
    datePicker = "",
    swatchSelect = "",
    multiSelect = "", // "",
    colorMultiSelect = "",
    toggle = "",
    radio = "",
    svgViewer = "",


    // column types
    text = "",
    number = "",
    boolean = "",
    color = "",
    date = "",
    // localized = "",

    manufacture = "",
    material = "",
    operation = "",
    opdetail = "",

    outputFieldDefault = "",
    outputFieldWordList = "",
    outputFieldWordText = "",
    outputFieldWordImage = "",
    outputFieldWordContainer = "",
    outputFieldCadAnnotation = "",
    outputFieldCadDimension = "",
    outputFieldCadDynamicComponent = "",
    outputFieldMate = "",
    outputFieldCustomProperty = "",
    outputFieldCadComponent = "",
    kbmaxNotifications = "",
    send = "",
}
